document.addEventListener('DOMContentLoaded', () => {

    const checkInventory = () => {
        const productForm = document.querySelector('product-form');
        productForm.checkValidProduct();
    }

    const colorElListener = () => {
        const colorFieldsetEl = document.querySelector('variant-radios');
        if (!colorFieldsetEl) return;
        colorFieldsetEl.addEventListener('click', e => {
            const { name, value, checked } = e.target;
            if (checked && (name === "Color" || value === "6GB/256GB")) setTimeout(checkInventory, 300);
        });
    }

    // /**
    //  * 控制 存储规格 / 颜色切换规则
    //  */
    // const changeColorRadiosEl = (disabled = true) => {
    //     const colorEl = document.querySelectorAll('variant-radios input[name="Color"]');
    //     colorEl.forEach((el) => {
    //         disabled ? el.classList.add('disabled') : el.classList.remove('disabled');
    //     });
    // };
    //
    // const disableColorRadios = (e) => {
    //     if (e) {
    //         e.preventDefault();
    //         e.stopPropagation();
    //     }
    // };
    //
    // // 6gb 版本选项单独处理
    // document.querySelector('input[value="6GB/256GB"]')?.addEventListener('change', (e) => {
    //     if (e.target.checked) {
    //         const colorFieldsetEl = document.querySelector('variant-radios #SingleOptionSelector-0');
    //         colorFieldsetEl.addEventListener('click', disableColorRadios);
    //         changeColorRadiosEl();
    //         setTimeout(checkInventory, 500);
    //     }
    // });
    //
    // // 4gb 版本选项单独处理
    // document.querySelector('input[value="4GB/128GB"]')?.addEventListener('change', (e) => {
    //     if (e.target.checked) {
    //         const colorFieldsetEl = document.querySelector('variant-radios #SingleOptionSelector-0');
    //         colorFieldsetEl.removeEventListener('click', disableColorRadios);
    //         changeColorRadiosEl(false);
    //     }
    // });

    const initFormExtends = () => {
        checkInventory();
        colorElListener();
    }

    initFormExtends();
})